import Container from './TableLayoutSelector.container';
import TableLayoutSelector from './TableLayoutSelector';

export default Container(TableLayoutSelector);
